module.exports = __webpack_public_path__ + "static/img/Bachelor_010738.8381d7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010738.jpg
// module id = 238
// module chunks = 0